var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("table", { staticClass: "fitstTable", attrs: { border: "1" } }, [
    _vm._m(0),
    _c(
      "tbody",
      [
        _vm._l(_vm.list, function (item, index) {
          return [
            _vm._l(item.curCourse, function (innerItem, innerindex) {
              return [
                _c("tr", { key: index + "-" + innerindex }, [
                  !innerindex
                    ? _c(
                        "td",
                        {
                          staticClass: "className",
                          attrs: { rowspan: item.curCourse.length },
                        },
                        [_vm._v(" " + _vm._s(item.className) + " ")]
                      )
                    : _vm._e(),
                  _c("td", { staticClass: "teachingTime" }, [
                    _vm._v(
                      _vm._s(innerItem.courseDate) +
                        " " +
                        _vm._s(innerItem.beginTime)
                    ),
                  ]),
                  _c("td", { staticClass: "projectName" }, [
                    _vm._v(_vm._s(innerItem.courseName)),
                  ]),
                  _c("td", { staticClass: "teachingTeachers" }, [
                    _vm._v(" " + _vm._s(innerItem.teacher) + " "),
                  ]),
                  _c("td", { staticClass: "teachingAddress" }, [
                    _vm._v(" " + _vm._s(innerItem.place) + " "),
                  ]),
                  !innerindex
                    ? _c(
                        "td",
                        {
                          staticClass: "weekschedule",
                          attrs: { rowspan: item.curCourse.length },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "schedule",
                              on: {
                                click: function ($event) {
                                  return _vm.clickschedule(item)
                                },
                              },
                            },
                            [_vm._v("一周课表")]
                          ),
                        ]
                      )
                    : _vm._e(),
                ]),
              ]
            }),
          ]
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("班次名称")]),
        _c("th", [_vm._v("授课时间")]),
        _c("th", [_vm._v("课程名称")]),
        _c("th", [_vm._v("授课教师")]),
        _c("th", [_vm._v("授课地点")]),
        _c("th", [_vm._v("查看课表")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }